var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.sesion._id)?_c('Menu'):_vm._e(),_c('v-content',[_c('div',{staticClass:"container"},[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }